import { ThingDocument } from '@cco/model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as AssetThingMapStore from './asset-thing-map.reducer';
import * as IotThingActions from './iot-thing.actions';
import * as ThingShadowStore from './thing-shadow.reducer';

export const featureKey = 'iotThings';

export interface FeatureRootState {
  [featureKey]: State;
}

export interface State {
  assetThingMaps: AssetThingMapStore.State;
  things: EntityState<ThingDocument>;
  shadows: ThingShadowStore.State;
}

const thingsAdapter: EntityAdapter<ThingDocument> = createEntityAdapter<ThingDocument>({
  selectId: thing => thing.thingName,
});

const thingsInitialState = thingsAdapter.getInitialState();

export const reducers: ActionReducerMap<State> = {
  assetThingMaps: AssetThingMapStore.reducer,
  things: createReducer(
    thingsInitialState,
    on(IotThingActions.upsertThing, (state, action): EntityState<ThingDocument> =>
      thingsAdapter.upsertOne(action.thing, state),
    ),
    on(IotThingActions.upsertThings, (state, action): EntityState<ThingDocument> =>
      thingsAdapter.upsertMany(action.things, state),
    ),
  ),
  shadows: ThingShadowStore.reducer,
};
